import { Skeleton, Typography } from '@mui/material';

export default function LoanCardSkeleton() {
    return (
        <div style={{ textAlign: 'center' }} className="!mt-10">
            {/* Skeleton for the image */}
            <Skeleton variant="rectangular" width={120} height={120} style={{ display: 'inline-block' }} />

            <>
                {false ? (
                    <>
                        {/* Skeleton for the approved message */}
                        <Skeleton variant="text" width={300} height={20} style={{ marginTop: '10px' }} />
                        <Skeleton variant="text" width={200} height={20} style={{ margin: '5px auto' }} />
                        <Skeleton variant="text" width={250} height={20} style={{ margin: '5px auto' }} />



                        {/* Skeleton for the table header */}
                        <div className="mt-3">
                            <Skeleton variant="rectangular" width="100%" height={40} />
                        </div>

                        {/* Skeleton for the table body */}
                        <div className="mt-3">
                            {[...Array(3)].map((_, index) => (
                                <Skeleton key={index} variant="rectangular" width="100%" height={40} style={{ marginTop: '10px' }} />
                            ))}
                        </div>
                    </>
                ) : (
                    <>
                        {/* Skeleton for the pending message */}
                        <Skeleton variant="text" width={300} height={20} style={{ marginTop: '10px' }} />
                        <Skeleton variant="text" width={250} height={20} style={{ margin: '5px auto' }} />
                    </>
                )}
            </>
        </div>
    );
}
